import React from "react";
import FilterCard, { FIELD_TYPE, ReactSelect } from "../FilterCard";
import {getPageOptions, hideModal, parseDate, showModalNoOutsideClick} from "../../util/FormatUtil";
import CheckinPatientModal from "../modals/CheckinPatientModal";
import Overlay from "../Overlay";
import moment from "moment";
import PodSelect from "../PodSelect";
import SimpleTable from "../tables/SimpleTable";
import { Sample } from "../../types/Sample";
import { sweetalert } from "../../App";
import Select from "react-select";
import TestType from "../../types/TestType";
import PodSched, {PodSchedForSelect} from "../../types/PodSched";
import { Column } from "../tables/TableBase";
import { Sorter, TableOrder } from "../../sorting/Sorter";
import ServicesAPI from "../../network/ServicesAPI";
import TestsAPI from "../../network/TestsAPI";
import SystemAPI from "../../network/SystemAPI";
import SamplesAPI, { SampleCheckinBody } from "../../network/SamplesAPI";
import Validator from "../../validation/Validator";
import { Validators } from "../../validation/Validators";
import AdminAPI from "../../network/AdminAPI";
import PaginationTool from "../PaginationTool";

interface CheckinState {
  showLoading: boolean;
  FirstName?: string;
  LastName?: string;
  SpecimenID?: string;
  DOB?: string;
  pod?: any;
  selectedSample?: Sample;
  totalAppts?: number;
  testTypes?: TestType[];
  FilterFirstName?;
  FilterLastName?;
  FilterDOB?;
  FilterReqNum?;
  FilterApptNum?;
  FilterFacility?;
  SpecimenSourceID?;
  Lot?;
  TestIDs?;
  ServiceID?
  direction?: TableOrder;
  services?
  facilities:{label:string, value:number}[]
  page_options: ReactSelect[];
  selected_page?;
  table_data?;
  pods: { label: string; value: PodSchedForSelect }[];
  specimenSources?;
}

export default class CheckIn extends React.Component<any, CheckinState> {
  private checkinRef: React.RefObject<CheckinPatientModal>;

  constructor(props) {
    super(props);
    this.state = {
      showLoading: false,
      testTypes: [],
      totalAppts: 0,
      direction: "asc",
      page_options: [{ value: "1", label: "1" }],
      selected_page: { value: 1, label: 1 },
      services: [],
      pods: [],
      specimenSources: [],
      facilities:[]
    };
    this.assignClearState = this.assignClearState.bind(this);
    this.assignClear2State = this.assignClear2State.bind(this);
    this.clear = this.clear.bind(this);
    this.submit = this.submit.bind(this);
    this.checkinRef = React.createRef();
    this.assignClearStatePod = this.assignClearStatePod.bind(this);
  }

  componentDidMount() {
    ServicesAPI.getServicesForWalkinForm().then((data) => {
      this.setState({services: data.data})
    });

    TestsAPI.getAllTestDetails().then((data) => {
      let enabledTests = data.tests.filter(t => t.IsEnabled)
      this.setState({testTypes: enabledTests})
    });

    AdminAPI.getAllPods(true, false).then(async response => {
      if(!response.success){
        sweetalert.fire("Error loading Pods.");
      }

      this.setState({pods:response.data as {label:string; value:PodSchedForSelect}[] })
    })

    SystemAPI.getAllSpecimenSourcesForTestingCheckin().then((data) => {
        this.setState({ specimenSources: data.data });
      });

    AdminAPI.getFacilitiesWithAddress(true).then( async data => {
        this.setState({facilities: data as {label:string;value:number}[], showLoading: false })
    })

    $(".editbtn").on("click", () => {
      $("#SpecimenID").triggerHandler("focus");
      $("#SpecimenID").trigger("touchstart");
    });
    $("#SpecimenID").on("touchstart", function () {
      $("#SpecimenID").triggerHandler("focus");
      $(this).triggerHandler("focus");
    });
  }

  clearFilterStatePod: () => void = null;

  assignClearStatePod(func) {
    this.clearFilterStatePod = func;
  }

  clearFilterState: () => void = null;

  assignClearState(func) {
    this.clearFilterState = func;
  }

  clearState = () => {
    this.clearFilterState();
  };

  clearFilter2State: () => void = null;

  assignClear2State(func) {
    this.clearFilter2State = func;
  }

  clear2State = () => {
    this.clearFilter2State();
  };

    submit(page) {
        if (!this.state.FilterDOB &&
            !this.state.FilterFirstName &&
            !this.state.FilterLastName &&
            !this.state.FilterReqNum  &&
            !this.state.FilterApptNum && 
            !this.state.FilterFacility &&
            !this.state.pod ) {
            return sweetalert.fire({icon: 'error', title: '', text: "Please select a filter"});
        }

    this.setState({ showLoading: true }, async () => {
      try {
        let result = await SamplesAPI.getFilteredSamplesForCheckin(page, {
          filter: {
            PatientFirstName: this.state.FilterFirstName,
            PatientLastName: this.state.FilterLastName,
            PatientDOB: parseDate(this.state.FilterDOB),
            ReqNum: this.state.FilterReqNum,
            LinkedApptsID: this.state.FilterApptNum,
            PodID: this.state.pod,
            Facilities: this.state.FilterFacility
          }
        })
        if (result.totalSamples < 1) {
          sweetalert.fire({ icon: 'error', title: '', text: 'No appointments were returned' });
          this.setState({ showLoading: false, table_data: [], totalAppts: 0 })
          return
        }
        this.setState({
          totalAppts: result.totalSamples,
          showLoading: false,
          page_options: getPageOptions(result.num_pages),
          table_data: result.table_data.sort((a, b) => a.ApptTime && moment(a.ApptTime, 'hh:mm a').diff(moment(b.ApptTime, 'hh:mm a')))
        })
      }
      catch (e) {
        console.error(e);
        sweetalert.fire({ icon: 'error', title: '', text: 'Search failed. Please try again.' });
        this.setState({ table_data: [], showLoading: false })
      }
    })
  }

  clear() {
    this.clearState();
    this.clear2State();
  }


    async onEdit(sample){

      if(!sample || !sample.SpecimenID || sample.SpecimenID.length < 8){
        return sweetalert.fire({icon: 'error', title: '', text: 'Specimen ID must be at least 8 characters.'})
      }

      let checkinBody = {
          ID:sample.ID,
          LinkedApptsID: sample.LinkedApptsID,
          PatientFirstName:sample.PatientFirstName.trim(),
          PatientLastName:sample.PatientLastName.trim(),
          PatientDOB:parseDate(new Date(sample.PatientDOB)),
          SpecimenSourceID:sample.SpecimenSourceID,
          ServiceID: sample.ServiceID,
          TestIDs: sample.TestIDs,
          SpecimenID: sample.SpecimenID ? sample.SpecimenID : null,
          Lot: sample.Lot ? sample.Lot : null,
          Memo: sample.Memo ? sample.Memo : null
      }

      let validator = new Validator<SampleCheckinBody>()
          .withSimpleValidation("PatientFirstName", Validators.requireNotBlankValidator("First Name"))
          .withSimpleValidation("PatientLastName", Validators.requireNotBlankValidator("Last Name"))
          .withValidation("PatientDOB", Validators.requireDOB(150, "Date of birth"))
          .withSimpleValidation("TestIDs", Validators.requireNonNullValidator("Tests"))
          .withSimpleValidation("SpecimenSourceID", Validators.requireNonNullValidator("Specimen Source"))
          
      let validationResponse = validator.validate(checkinBody);
    if (!validationResponse.success) {
      return sweetalert.fire({
        icon: "error",
        title: "",
        text: validationResponse.error,
      });
    }
    this.setState({ showLoading: true });
    hideModal(CheckinPatientModal.ID)
    let response = await SamplesAPI.editSample(checkinBody);
    this.setState({ showLoading: false });
    if (response.success) {
      sweetalert.fire({ icon: "success", title: "", text: "Checked In" });
      this.setState({ totalAppts: 0 })
      this.submit(1)
    } else {
      sweetalert.fire({
        icon: "error",
        title: "",
        text: `${response.reason}`,
      });
    }
  }

  useSorter(col: Column) {
    let sorter = new Sorter<any>()
      .withSorterFunc("ApptTime", (a, b) => {
        return moment(a, "hh:mm a").diff(moment(b, "hh:mm a"));
      })
      .withRawSorterFunc("Name", (a, b) => {
        let aName = a.PatientFirstName + " " + a.PatientLastName;
        let bName = b.PatientFirstName + " " + b.PatientLastName;
        return aName.localeCompare(bName);
      })
      .withRawSorterFunc("Service", (a: Sample, b: Sample) => {
        let aPod: { label: string; value: PodSchedForSelect } = this.state.pods.find(
          (p) => a.PodApptID === p.value.ID
        );
        let bPod: { label: string; value: PodSchedForSelect } = this.state.pods.find(
          (p) => b.PodApptID === p.value.ID
        );
        if (!aPod) return -1;
        if (!bPod) return 1;
        let aService = this.state.services.find(
          (s) => s.ID === aPod.value.ServiceIDs
        );
        let bService = this.state.services.find(
          (s) => s.ID === bPod.value.ServiceIDs
        );
        return aService && bService
          ? aService.Name.localeCompare(bService.Name)
          : 0;
      })
      .withSorterFunc("TestID", (a: number, b: number) => {
        let aTest = this.state.testTypes.find((t) => t.ID === a);
        let bTest = this.state.testTypes.find((t) => t.ID === b);
        if (!aTest) return -1;
        if (!bTest) return 1;
        return aTest.Name.localeCompare(bTest.Name);
      });

    this.setState({
      table_data: sorter.sortByKey(
        this.state.table_data,
        col.key as keyof any,
        this.state.direction
      ),
      direction: this.state.direction === "asc" ? "desc" : "asc",
    });
  }

  render():
    | React.ReactElement
    | string
    | number
    | {}
    | React.ReactNodeArray
    | React.ReactPortal
    | boolean
    | null
    | undefined {

      // console.log('Checkin state', this.state)


    return (
      <React.Fragment>
        <PaginationTool />
        <Overlay show_loading={this.state.showLoading} />
        <CheckinPatientModal
          key={this.state.selectedSample?.ID}
          onSubmit={(e) => this.onEdit(e)}
          selectedSample={this.state.selectedSample}
          tests={this.state.testTypes}
          sources={this.state.specimenSources}
          services={this.state.services}
          pod={this.state.pods.find(p => p.value.ID === this.state.selectedSample?.PodApptID)}
        />

            <div className="container-fluid  min-vh-100 ">
                <div className={"row"}>
                    <div className="col-12 col-md-12 col-lg-8 col-xl-5 pt-2">
                        <div className="card mb-2">
                            <div className="card-header verlag-bold">
                                <h4>Testing Check In</h4>
                            </div>
                            <div className="card-body">
                                <FilterCard passClearStateFunc={this.assignClearState}
                                            fields={[{
                                                label: "First Name",
                                                "key": "FilterFirstName",
                                                type: FIELD_TYPE.TEXT
                                            },
                                                {label: "Last Name", "key": "FilterLastName", type: FIELD_TYPE.TEXT,},
                                                {
                                                    label: "Date of Birth",
                                                    "key": "FilterDOB",
                                                    type: FIELD_TYPE.DATE,
                                                },
                                                {
                                                    label: "Facility", 
                                                    "key": "FilterFacility", 
                                                    type: FIELD_TYPE.SELECT,
                                                    options: this.state.facilities,
                                                    isMapped:true, isMulti:true, textType: 'text'
                                                }
                                            ]} filterChanged={(e) => this.setState(e)}/>
                                <PodSelect passClearStateFunc={this.assignClearStatePod} testing={true} active={true}
                                           multi={true} onChange={(e) => this.setState({pod: e.pod})}/>
                                <FilterCard passClearStateFunc={this.assignClear2State} fields={[
                                  {
                                    label: "Confirmation Code",
                                    "key": "FilterReqNum",
                                    type: FIELD_TYPE.TEXT,
                                    options: [],
                                    isMapped: true,
                                    onInput: (e) => e.target.value = e.target.value.toUpperCase()
                                },
                                {
                                  label: "Appointment Code",
                                  "key": "FilterApptNum",
                                  type: FIELD_TYPE.TEXT,
                                  options: [],
                                  isMapped: true,
                                  onInput: (e) => e.target.value = e.target.value.toUpperCase()
                              },
                                ]} filterChanged={(e) => this.setState(e)}/>
                            </div>
                            <div className="card-footer">
                                <button className="btn immySubmitButtonOutline" onClick={() => this.setState({
                                    selected_page: {
                                        label: 1,
                                        value: 1
                                    }
                                }, () => this.submit(1))}>Search
                                </button>
                                <button className="btn immyClearButtonOutline float-right" onClick={() => {
                                    this.clear();
                                    this.clearFilterStatePod();
                                    this.setState({pod: null})
                                }}>Clear Filter
                                </button>
                            </div>
                        </div>
                    </div>

              {this.state.totalAppts > 0 && (
              <div className="col-md-12 pt-2">
                <div className="card mt-2" style={{marginBottom: '4rem'}}>
                  <div className="card-header verlag-bold stickToTop">
                    <h4 className="text-center text-md-left">
                      Appointments
                      <section className="tableHeaderSection float-md-right d-flex justify-content-around">
                        <h4 style={{ float: "right" }}>
                          Total: {this.state.totalAppts}
                        </h4>
                        <h4 className="d-inline-block float-right align-middle pr-2 ml-5">
                          Page{" "}
                        </h4>
                        <div className=" align-middle float-right pages">
                          <Select
                            isSearchable={true}
                            placeholder={"1"}
                            noOptionsMessage={() => "No option"}
                            value={this.state.selected_page}
                            onChange={(e: ReactSelect) =>
                              this.setState({ selected_page: e }, () =>
                                this.submit(e.value)
                              )
                            }
                            className={"state_select page-num-select"}
                            options={this.state.page_options}
                          />
                        </div>
                      </section>
                    </h4>
                  </div>
                  <div className="card-body p-0 m-0 table-responsive">
                    <SimpleTable
                      columns={[
                        {
                          label: "Name",
                          key: "Name",
                          rawFormat: (v) => { 
                            return (
                              <a
                                href={"#!"}
                                className={'tableNameLinkColor'}
                                onClick={() =>
                                  this.setState(
                                    {
                                      selectedSample: JSON.parse(
                                        JSON.stringify(v)
                                      ),
                                    },
                                    () => showModalNoOutsideClick(CheckinPatientModal.ID)
                                  )
                                }
                              >
                                {v.PatientFirstName + " " + v.PatientLastName}
                              </a>
                            );
                          },
                        },
                        {
                          label: "DOB",
                          key: "PatientDOB",
                          formatFunc: parseDate,
                        },
                        {
                          label: "Appointment Code",
                          key: "LinkedApptsID",
                        },
                        {
                          label: "Confirmation Code",
                          key: "ReqNum",
                        },
                        {
                          label: "Specimen ID",
                          key: "SpecimenID",
                        },
                        {
                          label: "Guardian",
                          key: "Guardian",
                          rawFormat: (v: Sample) => {
                            return v.GuardianFirstName
                              ? v.GuardianFirstName + " " + v.GuardianLastName
                              : "";
                          },
                        },
                        {
                          label: "Appt. Time",
                          key: "ApptTime",
                          rawFormat: (v: Sample) => {
                            return v.ApptTime === "Invalid date"
                              ? ""
                              : v.ApptTime;
                          },
                        },
                      ]}
                      table_data={this.state.table_data}
                      columnClickedCallback={(col) => {
                        this.useSorter(col);
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
